import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { get, map } from 'lodash';
import { useTranslation } from 'react-i18next';  // Import de useTranslation

import i18n from '../../i18n';
import languages from './languages';

const LanguageDropdown = () => {
    const { i18n } = useTranslation();  // Accéder à i18n via useTranslation
    const [selectedLang, setSelectedLang] = useState("");

    useEffect(() => {
        // Initialisation de la langue au démarrage
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE") || "fr"; // Langue par défaut si non définie
        setSelectedLang(currentLanguage);
        i18n.changeLanguage(currentLanguage); // Change la langue dès le chargement
    }, [i18n]);  // Effet déclenché au premier rendu ou changement de langue

    const changeLanguageAction = (lang) => {
        i18n.changeLanguage(lang);  // Change la langue avec i18n
        localStorage.setItem("I18N_LANGUAGE", lang);  // Sauvegarde la langue dans localStorage
        setSelectedLang(lang);  // Met à jour l'état pour refléter la langue sélectionnée
    };

    const [isLanguageDropdown, setIsLanguageDropdown] = useState(false);
    const toggleLanguageDropdown = () => {
        setIsLanguageDropdown(!isLanguageDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown
                isOpen={isLanguageDropdown}
                toggle={toggleLanguageDropdown}
                className="ms-1 topbar-head-dropdown header-item"
            >
                <DropdownToggle
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                    tag="button"
                >
                    <img
                        src={get(languages, `${selectedLang}.flag`)}
                        alt="HeaderSection Language"
                        height="20"
                        className="rounded"
                    />
                    {/* Afficher l'initiale ou le nom de la langue */}
                    <span>{get(languages)}</span>
                </DropdownToggle>
                <DropdownMenu className="notify-item language py-2">
                    {map(Object.keys(languages), key => (
                        <DropdownItem
                            key={key}
                            onClick={() => changeLanguageAction(key)}
                            className={`notify-item ${selectedLang === key ? "active" : ""}`}
                        >
                            <img
                                src={get(languages, `${key}.flag`)}
                                alt="Language Flag"
                                className="me-2 rounded"
                                height="18"
                            />
                            <span className="align-middle">
                                {get(languages, `${key}.label`)}
                            </span>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default LanguageDropdown;
